import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import queryString from "query-string";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { clearLoginAsyncState, loginNew } from "redux/modules/authSlice";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 55,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function LoginPage_Darf() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { search } = useLocation();
  const queryParams = queryString.parse(search);

  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(clearLoginAsyncState());
  }, [dispatch]);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(clearLoginAsyncState());
      history.replace("/");
    }
  }, [isSuccess, isLoading, history, dispatch, isFailure]);

  const validationSchema = yup.object({
    password: yup.string().required("Password is required"),
    username: yup.string().required("Username is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      username: "",
      password: "",
    },
    isInitialValid: false,
    onSubmit: async (values) => {
      const data = {
        username: values.username,
        password: values.password,
      };
      // console.log(data);
      dispatch(loginNew(data));
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.root}>
        <Container maxWidth="sm" style={{ marginBottom: 20 }}>
          <Card className={classes.paper}>
            <CardContent className={classes.content}>
              <Typography variant="h4" className={classes.title}>
                Login
              </Typography>
              <Typography variant="h6">BOI VISA Service</Typography>
              <div className={classes.line} />
              <img
                alt="smart-visa"
                src="/assets/images/logoBoi.png"
                className={classes.logo}
              />
              <TextField
                label="Username"
                variant="outlined"
                style={{
                  marginTop: 5,

                  borderRadius: "5px",
                }}
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("username", formik)}
                helperText={getErrorMessage("username", formik)}
              />
              <TextField
                label="Password"
                variant="outlined"
                type="password"
                style={{
                  marginTop: 10,

                  borderRadius: "5px",
                }}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("password", formik)}
                helperText={getErrorMessage("password", formik)}
              />
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  color="secondary"
                  size="small"
                  className={classes.offlineLogin}
                  fullWidth={false}
                  disabled={isLoading}
                  to="/forgot_password"
                  component={Link}
                  // onClick={handleClickOffline}
                >
                  Forgot Password
                </Button>
              </div>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.submit}
                disabled={isLoading || !formik.isValid}
                type="submit"
                //   href={oneLoginURL}
              >
                {isLoading && (
                  <CircularProgress
                    color="secondary"
                    className={classes.loading}
                    size={18}
                  />
                )}
                Login
              </Button>

              <Button
                color="secondary"
                size="small"
                className={classes.offlineLogin}
                fullWidth={false}
                disabled={isLoading}
                to="/register"
                component={Link}
                //   onClick={handleClickOffline}
              >
                Register
              </Button>
            </CardContent>
          </Card>
        </Container>
      </div>
    </form>
  );
}
